import React from 'react';
import PropTypes from 'prop-types';
import "../../VehiculeForm.css";
import { vehiculeDataPropType } from '../../../../types/vehiculeTypes';

const DisplayVehiculeOccasion = ({ vehiculeData, readOnly }) => {
    return (
        <div className="form-section">
            <div className="section">
                <h3>MOTIF DE LA DEMANDE</h3>
                <div className="radio-group">
                    <label>RAISON:</label>
                    <div className="radio-group-child">
                    <div>
                            <input
                                type="radio"
                                name="raison"
                                value="7"
                                checked={vehiculeData.occ_ra_1?.toString() === "7"}
                                readOnly={readOnly}
                            />
                            <label>Carte grise</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="raison"
                                value="1"
                                checked={vehiculeData.occ_ra_1?.toString() === "1"}
                                readOnly={readOnly}
                            />
                            <label>Certificat</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="raison"
                                value="2"
                                checked={vehiculeData.occ_ra_1?.toString() === "2"}
                                readOnly={readOnly}
                            />
                            <label>Duplicata</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="raison"
                                value="3"
                                checked={vehiculeData.occ_ra_1?.toString() === "3"}
                                readOnly={readOnly}
                            />
                            <label>Correction</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="raison"
                                value="4"
                                checked={vehiculeData.occ_ra_1?.toString() === "4"}
                                readOnly={readOnly}
                            />
                            <label>Changement de domicile</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="raison"
                                value="5"
                                checked={vehiculeData.occ_ra_1?.toString() === "5"}
                                readOnly={readOnly}
                            />
                            <label>Changement d&apos;état civil ou matrimonial</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="raison"
                                value="6"
                                checked={vehiculeData.occ_ra_1?.toString() === "6"}
                                readOnly={readOnly}
                            />
                            <label>Changement de caractéristiques techniques</label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section">
                <h3>IDENTIFICATION DU VÉHICULE</h3>
                <div className="form-group">
                    <label>N° D&apos;IMMATRICULATION DU VÉHICULE (A):</label>
                    <input
                        type="text"
                        value={vehiculeData.occ_veh_27 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>DATE D&apos;ACHAT:</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label>JOUR</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_27_1 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                            />
                        </div>
                        <div className="date-field">
                            <label>MOIS</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_27_2 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                            />
                        </div>
                        <div className="date-field">
                            <label>ANNÉE</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_27_3 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label>DATE DE CERTIFICAT ACTUEL (I):</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label>JOUR</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_28_1 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                                placeholder="JJ"
                            />
                        </div>
                        <div className="date-field">
                            <label>MOIS</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_28_2 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                                placeholder="MM"
                            />
                        </div>
                        <div className="date-field">
                            <label>ANNÉE</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_28_3 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                                placeholder="AAAA"
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label>DATE DE 1ÈRE IMMATRICULATION (B):</label>
                    <div className="date-input-group">
                        <div className="date-field">
                            <label>JOUR</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_29_1 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                                placeholder="JJ"
                            />
                        </div>
                        <div className="date-field">
                            <label>MOIS</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_29_2 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                                placeholder="MM"
                            />
                        </div>
                        <div className="date-field">
                            <label>ANNÉE</label>
                            <input
                                type="text"
                                value={vehiculeData.occ_veh_29_3 || ""}
                                readOnly={readOnly}
                                className={readOnly ? "readonly" : ""}
                                placeholder="AAAA"
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label>N° DE FORMULE DU CERTIFICAT D&apos;IMMATRICULATION:</label>
                    <input
                        type="text"
                        value={vehiculeData.occ_veh_0 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>MARQUE (D.1):</label>
                    <input
                        type="text"
                        value={vehiculeData.veh_1 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>TYPE, VARIANTE, VERSION (D.2):</label>
                    <input
                        type="text"
                        value={vehiculeData.veh_2 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>DÉNOMINATION COMMERCIALE (D.3):</label>
                    <input
                        type="text"
                        value={vehiculeData.veh_4 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>N° IDENTIFICATION DU VÉHICULE (E):</label>
                    <input
                        type="text"
                        value={vehiculeData.veh_6 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>GENRE NATIONAL (J.1):</label>
                    <input
                        type="text"
                        value={vehiculeData.veh_13 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>N° D&apos;EXPLOITATION AGRICOLE:</label>
                    <input
                        type="text"
                        value={vehiculeData.occ_veh_30 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="form-group">
                    <label>KILOMÉTRAGE:</label>
                    <input
                        type="text"
                        value={vehiculeData.occ_veh_31 || ""}
                        readOnly={readOnly}
                        className={readOnly ? "readonly" : ""}
                    />
                </div>

                <div className="radio-group">
                    <label>PRÉSENCE DU CERTIFICAT D&apos;IMMATRICULATION:</label>
                    <div className="radio-group-child">
                        <div>
                            <input
                                type="radio"
                                name="presenceCertificat"
                                value="0"
                                checked={vehiculeData.occ_veh_32?.toString() === "0"}
                                readOnly={readOnly}
                            />
                            <label>NON</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="presenceCertificat"
                                value="1"
                                checked={vehiculeData.occ_veh_32?.toString() === "1"}
                                readOnly={readOnly}
                            />
                            <label>OUI</label>
                        </div>
                    </div>
                </div>

                {vehiculeData.occ_veh_32?.toString() === "1" && (
                    <div className="radio-group">
                        <label>FORMAT DU N° D&apos;IMMATRICULATION:</label>
                        <div className="radio-group-child">
                            <div>
                                <input
                                    type="radio"
                                    name="formatImmatriculation"
                                    value="1"
                                    checked={vehiculeData.occ_veh_32_1?.toString() === "1"}
                                    readOnly={readOnly}
                                />
                                <label>AB-123-CD</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    name="formatImmatriculation"
                                    value="2"
                                    checked={vehiculeData.occ_veh_32_1?.toString() === "2"}
                                    readOnly={readOnly}
                                />
                                <label>123-AB-45</label>
                            </div>
                        </div>
                    </div>
                )}

                {vehiculeData.occ_veh_32?.toString() === "0" && (
                    <div className="form-group">
                        <label>MOTIF D&apos;ABSENCE:</label>
                        <textarea
                            value={vehiculeData.occ_veh_32_2 || ""}
                            readOnly={readOnly}
                            className={readOnly ? "readonly" : ""}
                            rows="3"
                        />
                    </div>
                )}
            </div>

            <div className="section">
                <h3>NUANCE ET COULEUR DOMINANTE</h3>
                <div className="radio-group">
                    <label>NUANCE:</label>
                    <div className="radio-group-child">
                        <div>
                            <input
                                type="radio"
                                name="nuance"
                                value="0"
                                checked={vehiculeData.veh_33?.toString() === "0"}
                                readOnly={readOnly}
                            />
                            <label>CLAIR</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="nuance"
                                value="1"
                                checked={vehiculeData.veh_33?.toString() === "1"}
                                readOnly={readOnly}
                            />
                            <label>FONCÉ</label>
                        </div>
                    </div>
                </div>

                <div className="radio-group">
                    <label>COULEUR DOMINANTE:</label>
                    <div className="radio-group-child">
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="0"
                                checked={vehiculeData.veh_34?.toString() === "0"}
                                readOnly={readOnly}
                            />
                            <label>NOIR</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="1"
                                checked={vehiculeData.veh_34?.toString() === "1"}
                                readOnly={readOnly}
                            />
                            <label>MARRON</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="2"
                                checked={vehiculeData.veh_34?.toString() === "2"}
                                readOnly={readOnly}
                            />
                            <label>BLEU</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="3"
                                checked={vehiculeData.veh_34?.toString() === "3"}
                                readOnly={readOnly}
                            />
                            <label>ROUGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="4"
                                checked={vehiculeData.veh_34?.toString() === "4"}
                                readOnly={readOnly}
                            />
                            <label>BEIGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="5"
                                checked={vehiculeData.veh_34?.toString() === "5"}
                                readOnly={readOnly}
                            />
                            <label>ORANGE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="6"
                                checked={vehiculeData.veh_34?.toString() === "6"}
                                readOnly={readOnly}
                            />
                            <label>GRIS</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="7"
                                checked={vehiculeData.veh_34?.toString() === "7"}
                                readOnly={readOnly}
                            />
                            <label>JAUNE</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="8"
                                checked={vehiculeData.veh_34?.toString() === "8"}
                                readOnly={readOnly}
                            />
                            <label>VERT</label>
                        </div>
                        <div>
                            <input
                                type="radio"
                                name="couleur"
                                value="9"
                                checked={vehiculeData.veh_34?.toString() === "9"}
                                readOnly={readOnly}
                            />
                            <label>BLANC</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

DisplayVehiculeOccasion.propTypes = {
    vehiculeData: vehiculeDataPropType.isRequired,
    readOnly: PropTypes.bool
};

DisplayVehiculeOccasion.defaultProps = {
    readOnly: false
};

export default DisplayVehiculeOccasion;